import { Injectable } from '@angular/core';
import { User, UserRole } from '../model/user.model';
import { LocalStorage } from "../../shared/_api/localstorage";
import { CaseType } from '../model/caseType';


@Injectable({
  providedIn: 'root',
})
export class UserService {
    user: User;
    userRole : UserRole;
    caseType : CaseType = new CaseType();

    constructor() {}

    getUser() {
        if(this.user !== undefined){
            return this.user;
        }else{
            if(LocalStorage.user !== null){
                this.user = JSON.parse(LocalStorage.user);
                return JSON.parse(LocalStorage.user);
            }
            else return this.user;
        }
    }
    getCurrentUserRole(){
        if(this.userRole !==undefined){
            return this.userRole;
        }
        else{
            if(this.user !== undefined){
                this.user.userRoles.map(userRole =>{
                    if(userRole.userRoleId === this.user.userRoleId){
                        this.userRole = userRole;
                        return this.userRole;
                    }
                })
            }else{
                if(LocalStorage.user !== null){
                    this.user = JSON.parse(LocalStorage.user);
                    this.user.userRoles.map(userRole =>{
                        if(userRole.userRoleId === this.user.userRoleId){
                            this.userRole = {...userRole};
                        }
                    })
                    return this.userRole;
                    
                }
                else return this.userRole;
            }
        }
    } 
    getCaseType(caseTypeId){
        let caseTypes : CaseType[] = this.user.caseTypes.filter(item => item.id == caseTypeId);
        return caseTypes[0];
    }
}
